import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TaskUser } from '../tasks.types';

/** An employee with the avatar, as a task shows its creator, executor and observers */
@Component({
  selector: 'app-task-user',
  templateUrl: './task-user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'flex min-w-0' },
})
export class TaskUserComponent {
  /** Nothing for a user that is not in the list: the employees could not be loaded, or the user was removed */
  @Input() user: TaskUser | null | undefined = null;
  @Input() size = '24px';
}
